import { useParams } from 'react-router-dom';
import { getPopularArtistsByGenre } from "../data/artists";
import { getPopularAlbumsByGenre } from "../data/albums";
import { getPopularSinglesByGenre } from "../data/singles";
import HorizontalScrollArtists from "../components/HorizontalScrollArtists";
import MediaGridView from "../components/MediaGridView";
import SectionHeader from '../components/SectionHeader';
import Footer from '../components/Footer';
import NotFountParagraph from '../components/NotFountParagraph';

const Genre = () => {

  document.title = "Genre";
  
  const { genreName } = useParams();

  const popularArtistsByGenre = getPopularArtistsByGenre(genreName);
  const popularAlbumsByGenre = getPopularAlbumsByGenre(genreName);
  const popularSinglesByGenre = getPopularSinglesByGenre(genreName);

  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20 min-h-screen">
      {popularAlbumsByGenre.length > 0 || popularArtistsByGenre.length > 0 || popularSinglesByGenre.length > 0 ? (
        <div>
          <HorizontalScrollArtists 
            artists={popularArtistsByGenre} 
            headTitle={`Top Artists in ${genreName}`} 
          />
          <SectionHeader title={`Top Albums in ${genreName}`} />
          <MediaGridView route='album' collection={popularAlbumsByGenre} />
          <SectionHeader title={`Top Singles in ${genreName}`} />
          <MediaGridView route='single' collection={popularSinglesByGenre} />
        </div>
      ) : (
        <NotFountParagraph />
      )}
      <Footer />
    </div>
  );
};

export default Genre;